import React, { Component } from 'react'


class PDFToolbar extends Component {
  
  render () {
    return (
      <div className="Privacy">
        Privacy
      </div>
    )
  }
}

export default PDFToolbar
